module.exports = __webpack_public_path__ + "static/media/white_decoration.c2f35145.svg";